import { ServerConfig } from "@/config/config";
import { MailSettings } from "@/models/mail-settings";
import { Axios } from "@/utils/axios";
import { GoogleService } from "./google-service";

export class MailSettingsServiceClass {
	private readonly URL:string = `${ServerConfig.host}/mail-settings`

	public async getSettings():Promise<MailSettings[]>{
		let result = await Axios.get(`${this.URL}`);
		return ((result.data || []) as any[]).map(d=>new MailSettings(d));
	}

	public async getSettingsById(id:number):Promise<MailSettings>{
		let result = await Axios.get(`${this.URL}/${id}`);
		return new MailSettings(result.data);
	}

	public async getDefaultSettings():Promise<MailSettings>{
		let result = await Axios.get(`${this.URL}/default`);
		return new MailSettings(result.data);
	}

	public async createSettings(settings:MailSettings):Promise<MailSettings>{
		let result = await Axios.post(`${this.URL}`, settings.getJSON());
		return new MailSettings(result.data);
	}

	public async updateSettings(settings:MailSettings, test:boolean):Promise<MailSettings>{
		let result = await Axios.put(`${this.URL}/${settings.ID}?test=${test}`, settings.getJSON());
		return new MailSettings(result.data);
	}

	public async setDefault(settings:MailSettings):Promise<MailSettings>{
		let result = await Axios.post(`${this.URL}/${settings.ID}/set-default`);
		return new MailSettings(result.data);
	}

	public async deleteSettings(settings:MailSettings):Promise<void>{
		await Axios.delete(`${this.URL}/${settings.ID}`);
	}

	async gmailLogin(settings:MailSettings):Promise<void> {
		let code = await GoogleService.login();
		await Axios.post(`${this.URL}/${settings.ID}/gmail-login`, {Code: code, RedirectURL: window.location.origin});
	}

	async gmailLogout(settings:MailSettings):Promise<void> {
		await Axios.post(`${this.URL}/${settings.ID}/gmail-logout`, {});
	}

	async microsoftLogin(settings:MailSettings):Promise<void> {
		let response = await Axios.post(`${this.URL}/${settings.ID}/create-msal-login-link`);
		let result = response.data.Url;
		window.location = result;
	}

	async microsoftLogout(settings:MailSettings) {
		await Axios.post(`${this.URL}/${settings.ID}/microsoft-logout`);
		for (let i = localStorage.length; i >= 0; i--) {
			let key = localStorage.key(i);
			if (!key) continue;
			if (key.startsWith("msal.")) {
				localStorage.removeItem(key);
			}
		}
	}

	async getAllUsersSettings():Promise<MailSettings[]>{
		let result = await Axios.get(`${this.URL}/all`);
		return ((result.data || []) as any[]).map(r=>new MailSettings(r));
	}

	async getGoogleEmail(settings:MailSettings):Promise<string> {
		let result = await Axios.get(`${this.URL}/${settings.ID}/gmail/account`);
		return result.data.email;
	}

	async getMicrosoftEmail(settings:MailSettings):Promise<string>{
		let result = await Axios.get(`${this.URL}/${settings.ID}/microsoft/account`);
		return result.data.email;
	}
}

export const MailSettingsService = new MailSettingsServiceClass();